import axios from 'axios'

export const S3Client = axios.create({
    baseURL: '',
})
